import {useQuery} from '@tanstack/react-query'
import {getPtsLeadersApi} from '../../../apis/leader/payToSee'

const useQueryPaytoSee = () => {
    const {data, refetch} = useQuery({
        queryFn: async () => {
            const {data} = await getPtsLeadersApi()
            return {data}
        },
    })

    return {data: data?.data, refetch}
}

export default useQueryPaytoSee
